import { z } from 'zod'

export const highlightPatentExcerptsSchema = z
  .object({
    results: z.array(
      z.object({
        excerpt: z.string(),
        paragraph_index: z.number(),
      })
    ),
  })
  .describe('Highlight Patent Excerpts')
